export default __webpack_public_path__ + "static/media/CaennaVillage.6e53a14f.jpg";